import moment from "moment";
export default {

    data: function() {
        return {
            // stocke les key des conditions qui sont passés, et permet de retrouver une valeur originale si non gardé par l'action 
            listKeyNotGuardCond: [],
            directives: this.item.directives,

            //permet de savoir de quel champ provient le changement opéré sur ce champ
            modFromField : false,
            //valeur originales provenant de l'API 
            originalItems: this.item.liste,
            originalValField: this.valField,
            originalProps: this.item.defaultprops,
            // permet de faire la différence entre une selection sur la liste, ou l'ecriture de l'utilisateur (uniquement pour les textarea)
            // permet de ne pas lancer l'action si des valeurs des clés de la liste on été intétgré sur d'autres champs
            onSelect: false,

            // liste les conditions à appliquer uniquement si c'est un form
            specificCondition: (this.type != 'search') ? this.$store.getters['getConditionForm'](this.modalKey) : false,
        }
    },

    watch: {

        specificCondition: {

            handler(val) {

                this.watchSpecificConditions(val)
            },
            deep: true

        },


        valField(val) {

            if (this.type == 'search' || !this.directives) return;

            this.launchDirectives(val, false)

        }
    },


    methods: {

        //permet de lancer les conditions si elles sont dans le getter, pour le champ en question
        watchSpecificConditions(val) {

            if (val && val.conditions.find((item) => { return item[this.item.cle] })) {

                var storeCurrentKey = [];
                let cond = val.conditions.find((item) => { return item[this.item.cle] })

                // on stocke les actions qui ne doivent pas etre gardées si la condition change
                //lors du lancement de la condition, tout ceux qu'on ne garde pas "guard:false" sont stockés
                //quand une prochaine action sera faite, et entrainera le lancement de conditions, si le précédent changement a été supprimé on remet 
                //la valeur originale dans le champ.
                cond[this.item.cle].forEach((condition) => {
                    if (!condition.guard) this.listKeyNotGuardCond.push(condition)
                })

                if (this.listKeyNotGuardCond.filter(element => !storeCurrentKey.includes(element.key))) {
                    let removeAction = this.listKeyNotGuardCond.filter(element => !storeCurrentKey.includes(element.key))
                    removeAction.forEach((action) => {
                        switch (action.type) {
                            case 'props':
                                this.ApplyProps(this.originalProps)
                                break;
                            case 'valuefromfield':
                            case 'simplevalue':
                                this.items = this.originalItems;
                                this.change(this.item, this.originalValField, this.defaultValue)
                                break;
                        }
                        this.listKeyNotGuardCond = this.listKeyNotGuardCond.filter(element => element.key != action.key)
                    })
                }

                cond[this.item.cle].forEach((condition) => {
                    if (!condition.guard) this.listKeyNotGuardCond.push(condition)
                    storeCurrentKey.push(condition.key);

                    this.applySpecificCondition(condition)
                })


            }

        },

        //lance les directives du champ
        launchDirectives(val, firstLoad) {

            var fields = {}
                //execution des conditions si il y a :
            let resultFields = this.$store.getters.listForm(this.modalKey)
            this.directives.forEach((dir) => {
                    dir.then.forEach((then) => {

                        // si ce champ va faire l'objet d'une modif suite à un autre champ qui a été modifié par celui-ci (effet rebond), on ne le prend pas en compte.
                        if(then.field == this.modFromField) {
                            this.modFromField = false;
                            return;
                        }
                        fields[then.field] = { remove: [], insert: [] }
                        var find = false;
                        var value = this.replaceBy({ text: dir.if.value, page: this.modalKey })
                            //on stringify car si dans this.getReelValue() on fait un delete de l'action, il sera délété pour de bon.. et ne reviendra plus
                        let actions = JSON.parse(JSON.stringify(then.actions))
                            //permet de récupérer les vrai valeur en fonction des clés (pour les listes déroulantes)
                        let getActions = this.getReelValue(actions, firstLoad);

                        //stoppe l'action si le champ est un textarea ou textfield et que l'user ecrit ua lieu de sélectionner une valeur via une liste :
                        //enlevé car quand on ecrit, les conditions ne sont pas appliqué, ca bloque..
                        //if (this.onSelect === false && (this.item.format == 'textarea' || this.item.format == 'textfield')) return;
                        switch (dir.if.typechange) {

                            case '*':
                                if (val != '' && val != null) {
                                    fields[then.field].insert = getActions;
                                    find = true
                                }
                                break;

                            case 'value':
                                //si on cible une valeur d'une liste déroulante, on reprend toutes les clé pour checker la condition
                                if ((this.item.format == 'select' || this.item.format == 'autocomplete') && dir.if.key) {

                                    let array = this.items.find(el => el[this.defaultValue] == val);
                                    //lors du 1er chargement du form, le val peut etre undefined et ca créer une erreur sur array[dir.if.key].. donc if(val..)
                                    if (val && array[dir.if.key] == value) {
                                        fields[then.field].insert = getActions;

                                        find = true
                                    }
                                } else {
                                    if (Date.parse(val) == Date.parse(value) ||
                                        val == value) {
                                        fields[then.field].insert = getActions;
                                        find = true
                                    }
                                }

                                break;
                            case '!=':
                                //si on cible une valeur d'une liste déroulante, on reprend toutes les clé pour checker la condition
                                if ((this.item.format == 'select' || this.item.format == 'autocomplete') && dir.if.key) {
                                    let array = this.items.find(el => el[this.defaultValue] == val);

                                    if (val && array[dir.if.key] != value) {
                                        fields[then.field].insert = getActions;
                                        find = true
                                    }
                                } else {
                                    if (Date.parse(val) == Date.parse(value) ||
                                        val != value) {
                                        fields[then.field].insert = getActions;
                                        find = true
                                    }
                                }

                                break;
                            case 'like':
                                if (val.indexOf(value) != -1) {
                                    fields[then.field].insert = getActions;
                                    find = true
                                }
                                break;
                            case 'null':
                                if (val == '') {
                                    fields[then.field].insert = getActions;
                                    find = true
                                }
                                break;
                            case 'istrue':
                                if (val === true) {
                                    fields[then.field].insert = getActions;
                                    find = true
                                }
                                break;
                            case 'isfalse':
                                if (val === false) {
                                    fields[then.field].insert = getActions;
                                    find = true
                                }
                                break;
                            case 'issup':

                                if (Date.parse(val) > Date.parse(resultFields[dir.if.value]) ||
                                    val > resultFields[dir.if.value]) {
                                    fields[then.field].insert = getActions;
                                    find = true
                                }
                                break;
                            case 'isinf':
                                if (Date.parse(val) < Date.parse(resultFields[dir.if.value]) ||
                                    val < resultFields[dir.if.value]) {
                                    fields[then.field].insert = getActions;
                                    find = true
                                }
                                break;
                            case 'isequal':
                                if (Date.parse(val) == Date.parse(resultFields[dir.if.value]) ||
                                    val == resultFields[dir.if.value]) {
                                    fields[then.field].insert = getActions;
                                    find = true
                                }
                                break;
                            case 'iszerohour':
                                if (moment(val).format('HH:mm') == '00:00') {
                                    fields[then.field].insert = getActions;
                                    find = true
                                }
                                break;
                            default:
                                console.log(dir.if)
                                break;
                        }

                        if (!find) fields[then.field].remove = getActions;

                    })

                    this.$store.dispatch('changeConditionForm', { page: this.modalKey, datas: fields })
                })
                // 
            this.onSelect = false
        },


        getReelValue(actions, firstLoad) {

            let newActions = [];
            let getValue = this.items.find(item => item[this.defaultValue] == this.model)
                // on prend le nombre d'acton à appliquer. Quand le nombre est appliqué et que les actions sont finis,
                // On supprime les actions (dans le cas unique ou la sélection se fait sur un textarea)

                    for (let action of actions) {
                    if (firstLoad && !action.firstload) {
                        continue; // ici ça marche ✅
                    }

                    action.reelvalue = action.value;

                    if (this.items.length > 0 && (action.type === 'valuefromfield' || action.type === 'createoptionsfromarray')) {
                        if (action.value === "AllArray") {
                        action.reelvalue = getValue ? getValue : {};
                        } else {
                        action.reelvalue = getValue ? getValue[action.value] : "";
                        }
                    }
                    newActions.push(action);
                    }

            return newActions
        },

        applySpecificCondition(cond) {
            //permet de savoir à partir de quel champ on fait partir la condition (eviter les boucles)
            this.modFromField = (cond.fromField) ? cond.fromField : false;
            switch (cond.type) {

                case 'simplevalue':
                case 'valuefromfield':
                    if(this.item.format != 'autocomplete') {

                    var modi = (isNaN(cond.reelvalue)) ? cond.reelvalue : Number(cond.reelvalue)
                    this.keyup(this.item, modi)

                    } else {
                        if(this.item.liste.url) {
                        //si c'est d'une API    
                            this.items = []
                            let constructItems = {}
                            constructItems['text'] = cond.reelvalue;
                            //on récupère toutes les clés de construction de l'option pour lui attribuer la valeur qui mise à jour
                            this.item.liste.values.forEach((item) => {
                                constructItems[item.key] = cond.reelvalue;
                                if(item.defaultValue) this.defaultValue = item.key
                            })
                            this.items.push(constructItems)
                            //modification faite :
                        this.handleSelection(this.item,constructItems,this.defaultValue)
                        }  else {
                            // Autocomplete alimenté par une liste DB
                            const selectedItem = this.items.find(
                                option => option[this.defaultValue] == cond.reelvalue
                            )

                            if (selectedItem) {
                                this.handleSelection(
                                    this.item,
                                    selectedItem,
                                    this.defaultValue
                                )
                            }
                        }
                    }

                    break;

                case 'props':
                    // je fais le let pour faire la diff entre les props d'avants et ceux de maintenant.
                    this.ApplyProps(cond.value)
                    break;
                case 'filterbykey':

                    if (Array.isArray(cond.value)) {
                        this.items = []
                        cond.value.forEach((f) => {
                            let value = (!isNaN(f.reelvalue)) ? Number(f.reelvalue) : f.reelvalue;
                            switch (f.signe) {
                                case '=':
                                    this.originalItems.filter((el) => el[f.key] == value).forEach((v) => {
                                        this.items.push(v);
                                    })
                                    break;
                                case '!=':
                                    this.originalItems.filter((el) => el[f.key] !== value).forEach((v) => {
                                        this.items.push(v);
                                    })
                                    break;
                                case '>':
                                    this.originalItems.filter((el) => el[f.key] > value).forEach((v) => {
                                        this.items.push(v);
                                    })
                                    break;
                                case '<':
                                    this.originalItems.filter((el) => el[f.key] < value).forEach((v) => {
                                        this.items.push(v);
                                    })
                                    break;
                            }
                        })

                        // si sur la liste refaite, la valeur actuelle du champ ne correspond pas à une des options, on remet sa valeur à zero
                        if (!this.items.find((el) => el[this.defaultValue] === this.valField)) {
                            this.change(this.item, null, this.defaultValue)
                        }
                    }

                    break;

                case 'reloadOptions':
                    var fields = (this.$store.getters.listForm(this.modalKey)) ? this.$store.getters.listForm(this.modalKey)['fields'] : {};
                    this.API({
                            type: 'post',
                            url: 'engine/reloadOptions',
                            params: { field: { cle: this.item.cle }, filter: { params: this.params, fields: fields } }
                        })
                        .then((resp) => {
                            this.items = resp.data


                            this.getDefaultValue(this.items)

                            //newvalue : utilisé dans le mixins Fields.js, permet de mettre la nouvelle valeur fraichement inséré, après le rechargement de la liste
                            if (cond.newvalue) {
                                this.change(this.item, cond.newvalue, this.defaultValue)
                            } else {
                                //dans le cas d'un textarea on ne va pas changer la valeur, uniquement sur liste déroulante
                                if(this.item.defaultprops.multiple && (this.item.format == 'select' || this.item.format == 'autocomplete')) {
                                    let values = []
                                    this.items.forEach((item) => {
                                        if(this.valField && this.valField.includes(item[this.defaultValue])) values.push(item[this.defaultValue])
                                    })
                                    this.change(this.item, values, this.defaultValue)
                                }
                                if (!this.item.defaultprops.multiple && !this.items.find((el) => el[this.defaultValue] === this.valField) && (this.item.format == 'select' || this.item.format == 'autocomplete')) {
                                    this.change(this.item, null, this.defaultValue)
                                }
                                if (this.items.length == 1) {
                                    let result = (this.item.defaultprops.multiple) ? this.items : this.items[0];
                                    this.change(this.item, result, this.defaultValue)
                                }

                            }


                        })

                    break;
                case 'createoptionsfromarray':

                    if (Array.isArray(cond.value)) {
                        this.items = []
                        let createoptions = []
                        for (var i in cond.value) {
                            const option = { text: cond.value[i], value: cond.value[i] }
                            createoptions.push(option)
                        }
                        this.items = createoptions
                    }

                    break;

                case 'decalefurthur':
                    var mod = this.$store.getters.listForm(this.modalKey).fields[cond.value.fromField];
                    for (i in cond.value) {
                        if (i != 'fromField' || cond.value[i] != 0) mod = this.moment(mod).add(cond.value[i], i);
                    }
                    mod = this.moment(mod).format('YYYY-MM-DD HH:mm:00');
                    this.change(this.item, mod, this.defaultValue);

                    break;
                case 'decaleforward':
                    mod = this.$store.getters.listForm(this.modalKey).fields[cond.value.fromField];
                    for (i in cond.value) {
                        if (i != 'fromField' || cond.value[i] != 0) mod = this.moment(mod).subtract(cond.value[i], i);
                    }
                    mod = this.moment(mod).format('YYYY-MM-DD HH:mm:00');
                    this.change(this.item, mod, this.defaultValue);

                    break;
            }
        
        //un fois que les changements sont fait, on supprime la condition :
        let field = {}
        //si la condition est gardé "guard:true" on va la supprimer du store afin d'écouter les prochaines conditions qui arriveraient
        //car sinon, sur une prochaine action, ce champ sera mis à jour sur l'ancienne valeur donné de la  derniere condition;
        if(cond.guard) {
          field[this.item.cle] = { remove: [cond], insert : []}  
          this.$store.dispatch('changeConditionForm', { page: this.modalKey, datas: field })
        }
        
        },



        // fonction qui permet d'appliquer les propriété du champ
        ApplyProps(array, originalProps) {
            this.prop = array
                // si le champs n'est pas affiché, on remet sa valeur à zéro (uniquement si c'est dans un form et si les props ne sont pas celles d'origines) :
                // ex : j'ouvre un form avec un champ non visible par défaut, mais qui a une valeur. si une condition me dit de montrer ce champ, il faudra 
                //que la valeur soit présente, et non supprimée.. 
            if (!array.show && this.type != 'search' && !originalProps) {
                // this.keyup(this.item, '')
            }
            // on applique les propriété du champ par defaut           
            for (var cle in array) {
                this.applyRules(cle, array[cle])
            }
            this.applyRules('email', this.item.format === 'email')

        },

    },

    mounted() {

        if (this.type != 'search' && this.directives) {
            // on lance les directives si toutefois il y en a qui ont un firstload
            this.launchDirectives(this.valField, true);
            //on regarde si il n'y a pas deja de condition active pour le champ
            this.watchSpecificConditions(this.specificCondition);
        }

    }

}
